


























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { StoreModel, CrossCompanyPostingConfig } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { stripQuotes } from '@servicestack/client';
import {storeService} from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class CrossCompanyPostingPage extends Base {
  public storeViewModel: any = {};
  public storeModel: StoreModel = {};
  public stores: any[] = [];
  public crossCompanyConfigModel: CrossCompanyPostingConfig = {};
  public form: any = {};
  public crossCompanyConfigFields: Array<VFields<any>> = [];
  public storeId: string = '';
  public id: string = '';
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public requestProgress: boolean = false;

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'CrossCompany' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(
          false,
          this.$t('stores.crossCompanyPosting.alertInvalidForm')
        );
        this.resetMethodName(methodName);
        return;
      }
      this.saveCrossCompanyConfig();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.setShipmentProviderFields();
    if (this.$route.params.storeId) {
      this.storeId = this.$route.params.storeId;
      this.getStoreInfo();
    }
    this.id = this.$route.params.id;
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }
  public setShipmentProviderFields(): void {
    this.crossCompanyConfigFields = [
      {
        key: 'storeId',
        required: true,
        type: 'v-alynk-select',
        templateOptions: {
          required: true,
          disabled: false,
          label: this.$t(
            'stores.crossCompanyPosting.crossCompanyFields.selectStore'
          ) as string,
          text: 'dealershipName',
          value: 'id',
          items: this.stores,
          altag: 'Select Store',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Select Store', v)
          ],
          events: {
            onChange: (items, value) => {
              this.updateStore(value);
            },
          },
        },
      },
      {
        key: 'arAccount',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.crossCompanyPosting.crossCompanyFields.arAccount'
          ) as string,
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('AR Account', v)
          ],
        },
      },
      {
        key: 'arControl',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.crossCompanyPosting.crossCompanyFields.arControl'
          ) as string,
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('AR Control', v)
          ],
        },
      },
      {
        key: 'apAccount',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.crossCompanyPosting.crossCompanyFields.apAccount'
          ) as string,
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('AP Account', v)
          ],
        },
      },
      {
        key: 'apControl',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.crossCompanyPosting.crossCompanyFields.apControl'
          ) as string,
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('AP Control', v)
          ],
        },
      },
    ];
  }

  public async getStores(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.crossCompanyConfigFields, 'storeId');
      const response = await storeService.getStoresList();
      this.stores = response.results;
      const vm = this.crossCompanyConfigModel;
      const storeIds = await this.storeViewModel.storeJson.crossCompanyPostingConfigs.map(
        (x) => {
          if (x.storeId !== vm.storeId) {
            return x.storeId.toString();
          }
        }
      );
      // add current store for not including in select list
      storeIds.push(this.storeId);
      this.stores = this.stores.filter(function(e) {
        return this.indexOf(e.id.toString()) < 0;
      }, storeIds);
      this.setShipmentProviderFields();
    } finally {
      this.formlyHideSkeleton(this.crossCompanyConfigFields, 'storeId');
    }
  }

  public validateCrossCompanyConfig(): Vue & { validate: () => boolean } {
    return this.$refs.crossCompanyConfigForm as Vue & { validate: () => boolean };
  }


  public async saveCrossCompanyConfig(): Promise<void> {
    if(this.validateCrossCompanyConfig().validate()){
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (
          this.crossCompanyConfigModel &&
          this.crossCompanyConfigModel.storeId &&
          this.crossCompanyConfigModel.apAccount &&
          this.crossCompanyConfigModel.arAccount &&
          this.crossCompanyConfigModel.arControl &&
          this.crossCompanyConfigModel.apControl
        ) {
          await storeService.saveCrossPostingConfigProvider(
            Number(this.storeId),
            this.crossCompanyConfigModel
          );
          this.showAlert(true, this.$t('stores.crossCompanyPosting.alertSaved'));
          this.$router.push({
            name: 'admin.stores.edit',
            params: {
              tenantId: this.tenantId.toString(),
              enterpriseId: this.enterpriseId.toString(),
              storeId: this.storeId.toString(),
              tab:'CrossCompany'
            },
          });
        } else {
          this.showAlert(
            false,
            this.$t('stores.crossCompanyPosting.alertFillRequiredFields')
          );
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.crossCompanyConfigFields);
      const response = await storeService.getStore(Number(this.storeId));
      this.storeViewModel = response;
      this.storeModel.id = this.storeViewModel.id;
      this.storeModel.storeJson = this.storeViewModel.storeJson;
      const selectedCrossCompany = response.storeJson.crossCompanyPostingConfigs.find(
        (m) => m.id === this.id
      );
      if (selectedCrossCompany) {
        this.crossCompanyConfigModel = selectedCrossCompany;
        this.crossCompanyConfigModel.storeId = selectedCrossCompany.storeId.toString();
      }
      this.getStores();
    } finally {
      this.formlyHideSkeleton(this.crossCompanyConfigFields);
    }
  }

  public updateStore(storeId: number): void {
    const vm = this;
    this.stores.map((x) => {
      if (x.id === storeId) {
        vm.crossCompanyConfigModel.storeName = x.dealershipName;
        return;
      }
    });
  }
}
